/**
 * @ngdoc directive
 * @name cbl.insuranceloanpmi.mf.directive:creasPraticaPagamento
 * @restrict E
 * @description Componente che gestisce il sesto step "Pagamento" del dettaglio pratica
 * @param {Object[]} steps - Un array che rappresenta i sotto-step da visualizzare
 * @param {Object} currentStep - Rappresenta il sotto-step attualmente visualizzato
 */
(function() {
  'use strict';
  var CreasPraticaPagamentoCtrl = function(
    $http,
    $scope,
    $state,
    $stateParams,
    $window,
    $q,
    $httpParamSerializer,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    dettPraticaSrvc
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    $scope.msg = labelSrvc.getLabel;

    // Spinner
    this.spinner = dettPraticaSrvc.spinner;
    this.dettPraticaSrvc = dettPraticaSrvc;
    var self = this;
    
    /**
	 * @ngdoc method
	 * @name microTabClicked
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasPraticaPagamento
	 * @description Apre il micro-tab selezionato
	 * @param {Object} tab - il micro-tab selezionato
	 */
    this.microTabClicked = function(tab) {
    	if (self.dettPraticaSrvc.isPraticaNavigabile() !== true) {
    		return;
    	}
    	
    	self.dettPraticaSrvc.apriMicroTab(tab, 6);
    }

    // Si usa la promiseCambiaStep per eseguire il salvataggio
    dettPraticaSrvc.salva = function() {
      self.spinner.pratica = true;
      dettPraticaSrvc.datiPratica.prodotto.convenzione =
        dettPraticaSrvc.convenzione;
      $q
        .all({salvaConvenzione: dettPraticaSrvc.promiseSalvaConvenzione()})
        .then(
          function(response) {
            dettPraticaSrvc.datiPratica = response.salvaConvenzione.data.result;
            if (self.messaggiFctr.processaResponse(response.salvaConvenzione)) {
              return;
            }
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason.salvaConvenzione);
          }
        )
        .finally(function() {
          self.spinner.pratica = false;
        });
    };

    dettPraticaSrvc.nextStep = function() {
      self.spinner.pratica = true;
      dettPraticaSrvc.datiPratica.prodotto.convenzione =
        dettPraticaSrvc.convenzione;
      $q
        .all({nextStep: self.dettPraticaSrvc.promiseCambiaStep('/avantiStep')})
        .then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response.nextStep)) {
              return;
            }
            
            self.dettPraticaSrvc.datiPratica = response.nextStep.data.result;
            dettPraticaSrvc.generaTabs();
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason.nextStep);
          }
        )
        .finally(function() {
          self.spinner.pratica = false;
        });
    };

    /**
	 * @ngdoc method
	 * @name getStyleTabMicro
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasPraticaPagamento
	 * @description Imposta lo stile di visualizzazione per gli indicatori dei micro step
	 * @param {string} currentStep - Il macro step correntemente visualizzato
	 * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
	 * @return {string} - Restituisce lo stile da applicare all'indicatore del micro step
	 */
    this.getStyleTabMicro = function(currentTabIndex) {
    	// Pratica navigabile
  	  if (self.dettPraticaSrvc.isPraticaNavigabile() === true) {
  		if (currentTabIndex === self.currentStep.index) {
  	      return 'ab-step-tabs cliccabile active-read';
  	    }
  		
    	    return 'ab-step-tabs cliccabile ab-last-read';
        }
      	
        // Pratica non navigabile
        if (currentTabIndex < self.currentStep.index) {
          return 'ab-step-tabs';
        }
        
        if (currentTabIndex === self.currentStep.index) {
          return 'ab-step-tabs active';
        }
        
        return "ab-step-tabs ab-last";
    };
    
    /**
	 * @ngdoc method
	 * @name getStyleStepMicro
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasPraticaPagamento
	 * @description Imposta lo stile di visualizzazione per la barra dell'indicatore del micro step
	 * @param {string} currentStep - Il macro step correntemente visualizzato
	 * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
	 * @return {string} - Restituisce lo stile da applicare alla barra dell'indicatore del micro step
	 */
	  this.getStyleStepMicro = function(currentTabIndex) {
		if (self.dettPraticaSrvc.isPraticaNavigabile() === true) {
		  return 'step read';
		}
			
		  
	    if (currentTabIndex < self.currentStep.index) {
	      return 'step success';
	    }
	    
	    return 'step';
	  };
  };

  CreasPraticaPagamentoCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$window',
    '$q',
    '$httpParamSerializer',
    'CONSTANTS',
    'LabelSrvc',
    'CreasMessaggiFctr',
    'CreasDettaglioPraticaSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'creasDettaglioPratica/creasPraticaPagamento/creasPraticaPagamento.html'
    );
  };

  TemplateUrl.$inject = ['CONSTANTS'];

  var CreasPraticaPagamentoComponent = {
    bindings: {
      steps: '<',
      currentStep: '<'
    },
    controller: CreasPraticaPagamentoCtrl,
    controllerAs: 'creasPraticaPagamentoCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.insuranceloanpmi.mf')
    .component('creasPraticaPagamento', CreasPraticaPagamentoComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/creasDettaglioPratica/creasPraticaPagamento/creasPraticaPagamento.cmpt.js
// module id = 26
// module chunks = 0 1